import React from 'react';
import { connect } from 'react-redux';

import { Form } from 'components/common';
import MainFieldSet from './MainFieldSet';


const OrderForm = (props) => {
  const { showEditForm } = props.order;

  const onClose = () => {
    props.actions.order.showEditForm({ show: false });
  };

  const onSubmit = (data) => {
    const newData = Object.assign(data, {
      site: props.site.activeId,
    });
    props.actions.order.update(newData);
  };

  return (
    <Form
      width={800}
      title="Редактирование заказа"
      model={props.order}
      visible={showEditForm}
      onClose={onClose}
      onSubmit={onSubmit}
      initialValues={{ sort: 100 }}
      convertEditObject={(editObject) => ({
        ...editObject,
      })}
    >
      <MainFieldSet {...props} />
    </Form>
  );
};

const mapState = (state) => ({
  site: state.site,
  auth_token: state.auth.token,
  order: state.order,
});

const mapDispatch = (dispatch) => ({
  actions: {
    order: dispatch.order,
  },
});

export default connect(mapState, mapDispatch)(OrderForm);
